import React from "react";
import { Link } from "react-router-dom";

import {
  formatBdtAmount,
  formatDecimal,
  isPnlEligibleStage,
  navPerShareFromProject,
  nonApprovedPnlForProject,
  pendingPnlForProject,
  projectStageLabel,
} from "../../utils/assetManagerPnl";
import {
  projectApprovedNetPnlTotal,
  projectFundsRaisedCash,
  projectNetAssetsIssuedAtNav,
  projectTargetFundAtNav,
} from "../../utils/investmentPricing";
import { projectSupplyMetrics } from "../../utils/projectShareMetrics";
import { projectTitleWithCode } from "../../utils/projectViews";

export default function AssignedProjectCard({ project, pnlRows, onSubmitPnl }) {
  const pending = pendingPnlForProject(project.id, pnlRows);
  const submittedOpen = nonApprovedPnlForProject(project.id, pnlRows);
  const eligible = isPnlEligibleStage(project);
  const supply = projectSupplyMetrics(project);
  const metrics = [
    ["Total shares (cap)", formatDecimal(supply.totalShares, 2)],
    ["Current NAV (BDT)", navPerShareFromProject(project)],
    ["Total P&L (approved)", formatBdtAmount(projectApprovedNetPnlTotal(project))],
    ["Project current fund", formatBdtAmount(projectNetAssetsIssuedAtNav(project))],
    ["Funds raised", formatBdtAmount(projectFundsRaisedCash(project))],
    ["Target fund", formatBdtAmount(projectTargetFundAtNav(project))],
    ["Shares issued (outstanding)", formatDecimal(supply.issuedShares, 2)],
    ["Available (primary)", formatDecimal(supply.availableShares, 2)],
    ["Shareholders", String(supply.shareholders)],
  ];

  return (
    <li
      className="list-item"
      style={{
        display: "block",
        padding: "14px 16px",
        marginBottom: 12,
        border: "1px solid var(--border, #e2e8f0)",
        borderRadius: 10,
      }}
    >
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: 8, alignItems: "flex-start" }}>
        <div>
          <strong style={{ fontSize: 16 }}>{projectTitleWithCode(project)}</strong>
          {pending.length > 0 && (
            <span className="badge badge-PENDING" style={{ marginLeft: 8, verticalAlign: "middle" }}>
              {pending.length} pending P&amp;L
            </span>
          )}
        </div>
        <span className={`badge badge-${project.status}`}>{projectStageLabel(project)}</span>
      </div>

      <div
        style={{
          marginTop: 10,
          display: "grid",
          gap: "10px 18px",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          fontSize: 13,
        }}
      >
        {metrics.map(([label, value]) => (
          <div key={label}>
            <div className="muted" style={{ fontSize: 11, marginBottom: 2 }}>
              {label}
            </div>
            <div style={{ fontWeight: 600 }}>{value}</div>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: 14,
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          justifyContent: "flex-end",
        }}
      >
        {submittedOpen.length > 0 ? (
          <Link
            to={`/asset-manager/projects?section=submitted&project=${project.id}`}
            className="btn-secondary compact-btn"
            style={{ textDecoration: "none" }}
          >
            Submitted P&amp;L
          </Link>
        ) : (
          <Link
            to={`/asset-manager/history/pnl?project=${project.id}`}
            className="btn-secondary compact-btn"
            style={{ textDecoration: "none" }}
          >
            View approved P&amp;L
          </Link>
        )}
        {eligible ? (
          <button type="button" className="btn-secondary compact-btn" onClick={() => onSubmitPnl(project)}>
            {pending.length > 0 ? "Submit / update P&L" : "Submit P&L"}
          </button>
        ) : (
          <span className="muted" style={{ fontSize: 12, alignSelf: "center" }}>
            P&amp;L not available at this stage
          </span>
        )}
      </div>
    </li>
  );
}

